import { stringify } from 'qs';
import request from '../../utils/request';

// =====================机构===========================

export async function tree(params) {
  return request(`/api/blade-system/dept/tree?${stringify(params)}`);
}

export async function treeByAuthority(params) {
  return request(`/api/blade-system/dept/treeByAuthority?${stringify(params)}`);
}

export async function treeByArea(params) {
  return request(`/api/blade-system/dept/treeByArea?${stringify(params)}`);
}

export async function list(params) {
  return request(`/api/blade-system/dept/pageQuery?${stringify(params)}`);
}

export async function pureList(params) {
  return request(`/api/blade-system/dept/pureList?${stringify(params)}`);
}